<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<!-- <div class="order-query-form-box">
					<label for="start-date">货主名称：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.name"
							name="start-date"></span>
				</div> -->
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date"><span class="">订单支付时间<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker v-model="orderForm.paymentBeginTime" type="datetime" placeholder="选择日期时间"
							class="setTimePicker" value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker v-model="orderForm.paymentEndTime" type="datetime" placeholder="选择日期时间"
							class="setTimePicker" value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">支付方式:</label>
					<div class="st-dialog-item-input">
						<el-select v-model="orderForm.payWays" 
						placeholder="请选择" 
						multiple
						collapse-tags
						size="small">
							<el-option v-for="item in paymentStatList" 
							
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</div>
					<!-- <span class="order-query-form-input">
						<el-select v-model="orderForm.payWayStatus" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in paymentStatList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span> -->
				</div>
				<div class="order-query-form-box">
					<label for="start-date">支付类型:</label>
					<div class="st-dialog-item-input">
						<el-select v-model="orderForm.genres" 
						placeholder="请选择" 
						multiple
						collapse-tags
						size="small">
							<el-option v-for="item in paymentTypeList" 
							
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</div>
					<!-- <span class="order-query-form-input">
						<el-select v-model="orderForm.payWayStatus" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in paymentStatList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span> -->
				</div>
				<div class="order-query-form-box">
					<label for="start-date">支付状态:</label>
					<div class="st-dialog-item-input">
						<el-select v-model="orderForm.paymentStates" 
						placeholder="请选择" 
						multiple
						collapse-tags
						size="small">
							<el-option v-for="item in payList" 
							
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</div>
					<!-- <span class="order-query-form-input">
						<el-select v-model="orderForm.paymentState" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in payList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span> -->
				</div>
				<!-- <div class="order-query-form-box" style="width: 80px;" v-if="isSuperAdmin">
					<label for="start-date">加盟订单：</label>
					<span class="order-query-form-input">
					  <el-select v-model="orderForm.isFranchise" placeholder="请选择" class="stSetSelect">
						<el-option v-for="item in stWaybillList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					  </el-select>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">订单类型:</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.createFrom" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in createFromList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div> -->
				<div class="order-query-form-box">
					<label for="start-date">支付单号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.outTradeNo"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">运单号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.waybillNo"
							name="start-date"></span>
				</div>
				<!-- <div class="order-query-form-box">
					<label for="start-date">货主手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.phone"
							name="start-date"></span>
				</div> -->
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="data-table-box">
			<common-table 
				ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:showPage="togglePage"
				:showSummary="true"
				:count-data="dataTotal"
				:loading="loading" 
				:pageConfig="pageConfig" 
				:bottomHandleArr="bottomHandleArr"
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">
			</common-table>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'OrderPayment',
		props: [],
		components: {},
		data() {
			return {
				dataList: [], //数据列表
				dataTotal: {},
				loading: false,
				pageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1,
				},
				togglePage:false,
				bottomHandleArr: [
					{
						label: '导出',
						type: 'success',
						handler: () => this.exportTable()
					},
				],
				tableColumns: [
					{
						title: '订单支付时间',
						key: 'paymentTimeFormatted'
					},
					{
						title: '货主名称',
						key: 'name',
					},
					{
						title: '货主手机',
						key: 'phone',
					},
					{
						title: '公司名称',
						key: 'companyName',
					},
					{
						title: '金额',
						key: 'amount',
					},
					{
						title: '状态',
						key: 'paymentStateDesc',
					},
					{
						title: '订单号',
						key: 'relevanceId',
					},
					{
						title: '支付单号',
						key: 'outTradeNo',
					},
				],
				isSuperAdmin: false,
				orderForm: {
					name: null, //	货主名称	string	
					outTradeNo: null, //	微信支付：商户订单号/支付单号	string	
					paymentBeginTime: null, //	支付起始时间	string	格式：yyyy-MM-dd HH:mm:ss
					paymentEndTime: null, //	支付结束时间	string	格式：yyyy-MM-dd HH:mm:ss
					payWayStatus: null, // 0 余额支付 1 微信支付
					paymentState: null,
					genres:null,//支付状态
					createFrom: null,
					isFranchise: null,
					phone: null, //	货主手机	string	
					waybillNo: null, //	运单号	number
				},
				selDriverId: null, //选中的司机
				selectedList: [], // 选中的列表
				driverList: [], // 司机列表
				toggleStDialog: false, // 弹窗
				paymentStatList: [
					{
						value: null,
						label: '全部'
					},
					{
						value: 'ACCOUNT',
						label: '余额支付'
					}, 
					{
						value: 'WEIXIN',
						label: '微信支付'
					},
				],
				paymentTypeList:[
					{
						value: null,
						label: '全部'
					},
					{
						value: 'WAYBILL',
						label: '运单'
					}, 
					{
						value: 'MARGIN',
						label: '司机保证金'
					}, 
					{
						value: 'MEMBER',
						label: '司机会员'
					}, 
					{
						value: 'ACCOUNT',
						label: '钱包充值'
					}, 
					{
						value: 'INVOICEPOUNDAGE',
						label: '发票手续费'
					}, 
					{
						value: 'LOGISTICS_WAYBILL',
						label: '加盟物流运单'
					}, 
					{
						value: 'LOGISTICS_SPELL_WAYBILL',
						label: '加盟物流拼单'
					}, 
					{
						value: 'SCOREGOODSORDER',
						label: '积分商城订单'
					}, 
				],
				stWaybillList:[
					{
						value: null,
						label: '全部',
					},
					{
						value: 0,
						label: '未加盟',
					},
					{
						value: 1,
						label: '已加盟',
					},
				],
				createFromList: [
					{
						value: null,
						label: '全部',
					},
					{
						value: 'OWNER',
						label: '普通单',
					},
					{
						value: 'ADMIN',
						label: '拼单',
					}
				],
				payList: [
					{
						value: null,
						label: '全部'
					},
					{
						value: 'SUCCESS',
						label: '已支付'
					}, 
					{
						value: 'SUCCESSTOREFUND',
						label: '已退款'
					},
				],
			}
		},
		created() { },
		methods: {
			selectionChange(val) {
				this.selectedList = val;
			},

			sizeChange(size) {
				this.pageConfig.currentPage = 1
				this.pageConfig.pageSize = size
				this.searchList()
			},

			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage
				this.searchList()
			},

			searchList(flag) {
				this.loading = true
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if(flag) pages.current = 1;
				let orderForm = this.orderForm;
				Object.assign(orderForm, pages)
				orderForm.genres = orderForm.genres.toString()
				orderForm.payWays = orderForm.payWays.toString()
				orderForm.paymentStates = orderForm.paymentStates.toString()
				// this.$server.financial.getPaymentCount(orderForm, (res) => {
				// 	this.dataTotal = res.data
				// })
				console.log(orderForm)
				this.$server.financial.waybillPaymentPage(orderForm, (res) => {
					this.loading = false
					if (res.code == 0) {
						this.dataList = res.data.records;
						this.pageConfig.total = res.data.total;
						this.pageConfig.currentPage = res.data.current;
						if(res.data.total>0){
							this.togglePage=true;
						}
					}
				})
			},

			// 导出
			exportTable() {
				let that = this;
				if (this.dataList.length == 0) {
					that.$toast.stMessage('暂无订单', true)
					return;
				}
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				let orderForm = this.orderForm;
				Object.assign(orderForm, pages)
				this.$server.financial.waybillPaymentPageExport(orderForm, (res) => {
					var blob = new Blob([res.data], {
						type: "application/vnd.ms-excel;charset=UTF-8"
					});
					var objectUrl = URL.createObjectURL(blob);
					var a = document.createElement('a');
					a.href = objectUrl;
					//导出文件名
					var fileName = new Date().getTime();
					a.download = "数据表格-" + fileName + ".xls";
					a.target = '_blank';
					a.click();
				})


			},
		},
		mounted() { 
			// 判断是否是超级管理员
			this.$server.role.getRoleOfUser(this.$store.getters.id, res => {
				if (res.data.length>0) {
				this.isSuperAdmin = true
				}
			})
		}
	}
</script>
<style scoped>
	.order-payment {
		width: 100%;
		height: auto;
	}

	.data-table-box {
		height: auto;
		background: #FFF;
		padding: 8px;
		box-sizing: border-box;
	}

	.data-table {
		margin-bottom: 8px;
	}

	.query-setting-box-left {
		flex-grow: 0;
	}

	.order-query-form-submit {
		margin-left: 24px;
	}
</style>